export const COMMAND_NEW_POLL = 'new-poll';
export const COMMAND_ANSWER_POLL = 'answer-poll';
export const COMMAND_OLD_POLLS = 'old-polls';
export const CHAR_LIMIT = 500;
export const ANSWERS_LIMIT = 255;
/**
 * Poll types for single-select vs multi-select functionality.
 */
export var POLL_TYPE;
(function (POLL_TYPE) {
    POLL_TYPE["SINGLE_SELECT"] = "single-select";
    POLL_TYPE["MULTI_SELECT"] = "multi-select";
})(POLL_TYPE || (POLL_TYPE = {}));
